export type AssetLibraryTabKey = 'personal' | 'team' | 'official';

export interface AssetLibraryTabItem {
  /** 仅阻止切换，仍保留 Tab 展示以保持资产库信息架构完整。 */
  disabled?: boolean;
  key: AssetLibraryTabKey;
  label: string;
}

export const ASSET_LIBRARY_LAST_TAB_STORAGE_KEY = 'roboneo_asset_library_last_tab';

const ASSET_LIBRARY_DEFAULT_TAB: AssetLibraryTabKey = 'official';

const ASSET_LIBRARY_TAB_KEYS: AssetLibraryTabKey[] = ['personal', 'team', 'official'];

/**
 * 判断缓存值是否是资产库已知 tab。
 */
export function isAssetLibraryTabKey(value: string | null | undefined): value is AssetLibraryTabKey {
  return ASSET_LIBRARY_TAB_KEYS.includes(value as AssetLibraryTabKey);
}

/**
 * 根据当前账号作用域返回可见资产库 tab，团队账号隐藏个人资产，个人账号隐藏团队资产。
 */
export function getVisibleAssetLibraryTabs(
  isTeamAssetLibrary: boolean,
  labels: Record<AssetLibraryTabKey, string>,
): AssetLibraryTabItem[] {
  const accountTab: AssetLibraryTabKey = isTeamAssetLibrary ? 'team' : 'personal';
  const visibleTabKeys: AssetLibraryTabKey[] = [accountTab, 'official'];
  return visibleTabKeys.map((key) => ({
    key,
    label: labels[key],
  }));
}

/**
 * 将缓存或切换目标归一化到当前账号作用域可展示的资产库 tab。
 */
export function normalizeAssetLibraryTab(
  value: string | null | undefined,
  isTeamAssetLibrary: boolean,
): AssetLibraryTabKey {
  if (!isAssetLibraryTabKey(value)) {
    return ASSET_LIBRARY_DEFAULT_TAB;
  }
  if (value === 'official') {
    return value;
  }
  if (value === 'personal' && isTeamAssetLibrary) {
    return 'team';
  }
  if (value === 'team' && !isTeamAssetLibrary) {
    return 'personal';
  }
  return value;
}
